$(document).ready(function () {
    if ($('.assistant__module').length > 0) {

        $('#first_level_assistant').selectmenu();
        $('#second_level_assistant').selectmenu();
        $('#third_level_assistant').selectmenu();
        $('.second_level_select').fadeOut();
        $('.third_level_select').fadeOut();

        let second_level_assistant = $('#second_level_assistant').attr('data-select'),
            third_level_assistant = $('#third_level_assistant').attr('data-select');

        second_level_assistant = JSON.parse(second_level_assistant);
        third_level_assistant = JSON.parse(third_level_assistant);

        /** First level dropdown menu */
        $('#first_level_assistant').on('selectmenuchange', function() {

            $('#second_level_assistant').selectmenu().selectmenu('destroy');

            let select_val = $(this).find('option:selected').val(),
                options = "";

            $('.assistant__module #select_link').fadeOut();

            options += '<option value="none" data-link="" data-linktitle="">Please, select an option..</option>';

            $.each(second_level_assistant[select_val], function(index, value) {
                options += '<option value="' + value.option_value + '" data-link="' + value.link + '" data-linktitle="' + value.link_title + '">' + value.title + '</option>';
            });

            $('#second_level_assistant').html(options);
            $('#second_level_assistant').selectmenu().selectmenu('refresh');

            if (select_val !== "none") {
                $('.second_level_select').fadeIn();
                $('.third_level_select').fadeOut();
            } else {
                $('.second_level_select').fadeOut();
                $('.third_level_select').fadeOut();
            }

        });

        /** Second Level Dropdown Menu */
        $('#second_level_assistant').on('selectmenuchange', function() {

            let select_val = $(this).find('option:selected').val(),
                parent_val = $('#first_level_assistant').val(),
                options = "";

            if (select_val == "none") {
                $('.third_level_select').fadeOut();
            }

            if (typeof third_level_assistant[parent_val + '-' + select_val] !== 'undefined' && third_level_assistant[parent_val + '-' + select_val] !== false) {
                $('#third_level_assistant').selectmenu().selectmenu('destroy');

                options += '<option value="none" data-link="" data-linktitle="">Please, select an option..</option>';

                $.each(third_level_assistant[parent_val + '-' + select_val], function(index, value) {
                    options += '<option value="' + value.option_value + '" data-link="' + value.link + '" data-linktitle="' + value.link_title + '">' + value.title + '</option>';
                });

                $('#third_level_assistant').html(options);
                $('.assistant__module #select_link').fadeOut();

                $('#third_level_assistant').selectmenu();
                $('.third_level_select').fadeIn();

            } else {
                let link = $('#second_level_assistant').find('option:selected').attr('data-link'),
                    link_title = $('#second_level_assistant').find('option:selected').attr('data-linktitle');
                $('.assistant__module #select_link').attr('href', link).text(link_title);
                $('.assistant__module #select_link').fadeIn();
                $('.third_level_select').fadeOut();

            }

        });

        /** Third level dropdown menu */
        $('#third_level_assistant').on('selectmenuchange', function() {

            let select_val = $(this).find('option:selected').val();

            if (select_val !== "none") {
                let link = $(this).find('option:selected').attr('data-link'),
                    link_title = $(this).find('option:selected').attr('data-linktitle');

                $('.assistant__module #select_link').attr('href', link).text(link_title);
                $('.assistant__module #select_link').fadeIn();
            } else {
                $('.assistant__module #select_link').fadeOut();
            }

        });
    }
});